class ProductBadges extends HTMLElement {
  constructor() {
    super();
    this.saleBadge = this.querySelector('.badge--sale');
  }

  connectedCallback() {
    // Listen for variant changes
    document.addEventListener('variant-change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant) return;
    if (!this.saleBadge) return;

    // Check if the variant has a sale price, then update the sale badge
    if (variant.compare_at_price > variant.price) {
      const discount = Math.round(
        ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
      );
      const salePercentElement = this.saleBadge.querySelector('[data-sale-percent]');
      if (salePercentElement) salePercentElement.textContent = discount;
      this.saleBadge.classList.remove('hidden');
    } else {
      this.saleBadge.classList.add('hidden');
    }
  }
}

customElements.define('product-badges', ProductBadges);
